module.exports = __webpack_public_path__ + "images/overweight.5403567da0d4115095b493c76bedda52.png";